<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div>
            <span class="theme-color-one">ส่วนที่ 5 :</span> เอกสารแนบ
          </div>
          <Button
              theme="6"
              @onClick="addAttachment"
          >
            + เพิ่มไฟล์
          </Button>
        </div>

        <!-- Form 1 -->
        <div>
          <div class="theme-color-seven mb-3">
            *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 10 mb/ไฟล์)
          </div>

<!--          <div class="d-flex flex-column gap-16">-->
<!--            <div-->
<!--                v-for="(item, i) in attachment"-->
<!--                :key="i"-->
<!--                class="d-flex gap-16"-->
<!--            >-->
<!--              <div-->
<!--                  class="flex"-->
<!--                  style="max-width: 500px"-->
<!--              >-->
<!--                <v-file-input-->
<!--                    prepend-icon-->
<!--                    solo-->
<!--                    flat-->
<!--                    class="custom-textfield-theme-3"-->
<!--                    :placeholder="item.file_name ? item.file_name : 'เลือกไฟล์'"-->
<!--                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"-->
<!--                    v-model="files[i]"-->
<!--                ></v-file-input>-->
<!--              </div>-->

<!--              <Button-->
<!--                  theme="3"-->
<!--                  @click.native="uploadFile(i)"-->
<!--              >อัพโหลด</Button>-->
<!--            </div>-->
<!--          </div>-->

          <v-layout class="mt-3" v-for="(file, f) in attachment" :key="f">
            <v-flex xs7>
              <v-file-input
                  v-model="files[f]"
                  :id="'file' + f"
                  :rules="rulesFile"
                  color="#F15A29"
                  style="border-radius: 30px"
                  outlined
                  height="36"
                  placeholder=""
                  prepend-icon=""
                  accept="application/pdf,.doc,.docx"
                  v-show="
                      checkValType(file.file_name) == 'object' ||
                      file.file_name == '' ||
                      file.file_name == null
                    "
                  @change="addToAttachment(files[f])"
              ></v-file-input>
              <v-text-field
                  v-show="checkValType(file.file_name) == 'string'"
                  v-model="file.file_name"
                  outlined
                  height="36"
                  color="#F15A29"
                  style="border-radius: 30px"
                  readonly
              ></v-text-field>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn
                  depressed
                  dark
                  rounded
                  width="100"
                  color="#464647"
                  @click="selectFile(f)"
              >
                <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                <span class="font-12 font-w-700">อัพโหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              <v-btn
                  depressed
                  height="35"
                  width="35"
                  fab
                  dark
                  color="#FD0C0C"
                  @click="removeFile(f)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

        </div>

      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import { eventBus } from "../../../plugins/global-funcs"
import { mapState } from "vuex"
import axios from "axios";

export default {
  name: "CFormAttachment",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: [],
      files: [],
      attachment: [{}],
      rulesFile: [
        (value) =>
            !value ||
            value.size < 10000000 ||
            "File size should be less than 10 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    }
  },
  watch: {
    files: {
      handler (val) {
        this.form = this.attachment
        console.log('this.form@watch', this.form)
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      AttachmentForm: state => state.CForm.AttachmentForm
    })
  },
  created () {
    if (this.isSameId) this.form = this.AttachmentForm
    eventBus.$on('cFormAttachment', () => {
      eventBus.$emit('cFormAttachmentSend', this.form)
    })

    if(this.masterData.form_c.attachments){
      this.form = this.masterData.form_c.attachments
      this.attachment = []
      //push each of this.masterData.form_c.attachments into this.attachment
      console.log('Attachment this.form', this.form)
      this.masterData.form_c.attachments.forEach((item) => {
        this.attachment.push(item)
        console.log('attachment@created', this.attachment)
      })
    }

    eventBus.$on('cFormSummary', () => {
      this.$store.commit('CForm/addSummaryData', {
        partFiveAttachment: this.attachment
      })
    })
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    addAttachment () {
      this.form = this.attachment
      console.log('addAttachment')
      this.attachment.push({})
    },
    addToAttachment(file){
      //add file in to last index of attachment
      this.attachment[this.attachment.length - 1] = file
      console.log('addToAttachment', this.attachment)
    },
    removeFile(id) {
      this.attachment.splice(id, 1);
      this.form = this.attachment
      console.log('removeFile', this.form)
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },
  }
}
</script>

<style scoped>

</style>